<template>
    <div class="chart-container">
        <div class="label">
            {{ model.label }}
        </div>
        <div class="chart-body">
            <div class="values">
                <div
                    v-for="(range, i) in ranges"
                    :key="i"
                    class="value-container"
                >
                    <div class="secondary-label">
                        {{ range.label }}
                    </div>
                    <div class="lga-value">
                        {{ range.valueString }}<span class="lga-units">{{ model.units }}</span>
                    </div>
                    <div class="compare-value">
                        {{ range.compareValueString }}
                    </div>
                </div>
            </div>
            <dynamic-resize-container
                class="population-chart"
            >
                <template
                    #default="{width}"
                >
                    <population-chart
                        v-if="width > 0"
                        :width="width"
                        :height="200"
                        :values="values"
                        :compare-values="compareValues"
                    >
                        <template
                            #tooltip-content="{ value: {  label, rawX, group, x, compareX, ...rest } }"
                        >
                            <div>
                                <div class="tooltip-group">
                                    {{ label }}
                                </div>
                                <div class="tooltip-raw-value">
                                    {{ model.options.rawValueFormat(rawX) }} {{ group }}s
                                </div>
                                <div class="tooltip-pct">
                                    {{ model.options.tooltipFormat(x) }}<span class="tooltip-lga-units">{{ model.units }}</span>
                                </div>
                                <div class="tooltip-location">
                                    of {{ model.localName }}
                                </div>
                                <div class="tooltip-compare-pct">
                                    {{ model.options.tooltipFormat(compareX) }}{{ model.units }} {{ model.comparisonText }}
                                </div>
                            </div>
                        </template>
                    </population-chart>
                </template>
            </dynamic-resize-container>

            <info-tooltip
                :definition="model.definition"
                :link-to-health="model.linkToHealth"
                :data-source="model.dataSource"
            />
        </div>
    </div>
</template>

<script>
import DynamicResizeContainer from '@/components/DynamicResizeContainer.vue';
import PopulationChart from '@/components/PopulationChart.vue';
import InfoTooltip from '@/components/InfoTooltip.vue';

export default {
    components: {
        DynamicResizeContainer, PopulationChart, InfoTooltip
    },
    props: {
        model: {
            type: Object,
            required: true
        }
    },
    computed: {
        values() {
            return this.model.values;
        },
        compareValues() {
            return this.model.compareValues;
        },
        ranges() {
            return this.model.proportionsInRanges;
        }
    }
};
</script>

<style src="./common.container.css" scoped></style>
<style lang="postcss" scoped>
.chart-container {
    @apply relative;
}

.chart-body {
    @apply flex flex-row justify-between items-center h-40 mt-4;
}

.population-chart {
    @apply flex-grow relative;
    min-width: 100px;
}

.pdf .resize-container.population-chart {
    min-width: 250px;
    max-width: 250px;
}

.values {
    @apply flex flex-col flex-grow-0 h-full justify-between;
    min-width: 90px;
}

.value-container {
    @apply text-left;
}

.value-container .label {
    @apply text-left uppercase font-bold;
}

.tooltip-group {
    @apply text-neutral-label text-xs leading-relaxed;
}
.tooltip-raw-value {
    @apply text-2xs leading-relaxed;
}
.tooltip-pct {
    @apply font-bold text-xl leading-none;
}
.tooltip-location {
    @apply text-2xs leading-relaxed;
}
.tooltip-compare-pct {
    @apply text-neutral-text text-2xs leading-relaxed;
}

/* @screen sm { */
    .value-container .label { @apply text-xs; }
    .values {@apply mr-2;}
/* } */
@screen md {
    .value-container .label { @apply text-sm; }
    .values {@apply mr-4;}
}
@screen lg {
    .values { @apply mr-8; }
}
</style>
